import CoordinatesComponent from "./components/CoordinatesComponent/CoordinatesComponent";
import LayerTreeComponent from "./components/LayersTreeComponent/LayerTreeComponent";
import SpatialAnalysisComponent from "./components/SpatialAnalysisComponent/SpatialAnalysisComponent";
import ToolbarComponent from "./components/ToolbarComponent/ToolbarComponent";

export const config = {
  ESRI_API_KEY:
    "AAPKe45036761f9a497c9052a704b6ad049bIljfra2b59baaLxaoY6MAF4OjMPo9wn19vi-7xs-eG70Aoe1lXtH9WWAWsky2LeK",
  INIT_ZOOM: 6,
  SEARCH_URL: "https://services.gugik.gov.pl/uug/?request=GetAddress",
  EXTEND: {
    xmin: 20.9,
    ymin: 52.22,
    xmax: 21.05,
    ymax: 52.23,
  },

  LAYOUT: {
    elements: [
      {
        id: "CoordinatesComponentID",
        position: "bottom-right",
        component: CoordinatesComponent,
        props: ["view"],
      },
      {
        id: "SpatialAnalysisComponentID",
        position: "top-left",
        component: SpatialAnalysisComponent,
      },
      // {
      //   id: "LayerTreeComponentID",
      //   position: "top-right",
      //   component: LayerTreeComponent,
      // },
      {
        id: "ToolbarComponentID",
        position: "top-right",
        component: ToolbarComponent,
      },
    ],
  },

  LAYERS: [
/*     {
      id: "3",
      url: "https://services.arcgis.com/V6ZHFr6zdgNZuVG0/arcgis/rest/services/Landscape_Trees/FeatureServer/0",
      title: "Drzewa",
      visible: true,
      geometryType: "point",
    },
    {
      id: "34",
      url: "https://services9.arcgis.com/RHVPKKiFTONKtxq3/arcgis/rest/services/USGS_Seismic_Data_v1/FeatureServer/0",
      title: "Trzesienia1",
      visible: true,
      geometryType: "point",
    },
    {
      id: "35",
      url: "https://services9.arcgis.com/RHVPKKiFTONKtxq3/arcgis/rest/services/USGS_Seismic_Data_v1/FeatureServer/1",
      title: "Shake Intensity",
      visible: true,
      geometryType: "point",
    },
    {
      id: "37",
      url: "https://services.arcgis.com/V6ZHFr6zdgNZuVG0/arcgis/rest/services/Landscape_Trees/FeatureServer/0",
      title: "Drzewa2",
      visible: false,
      geometryType: "point",
    },
    {
      id: "3888",
      url: "https://services.arcgis.com/V6ZHFr6zdgNZuVG0/arcgis/rest/services/Landscape_Trees/FeatureServer/0",
      title: "Drzewa3",
      visible: true,
      geometryType: "point",
    }, */
  ],

  QUERY: {
    buildInQueryFilter: [
      { key: 'node["name"]', value: "Point", category: "General" },
      { key: 'way', value: "Line", category: "General" },
      { key: 'relation["type"="multipolygon"]', value: "Relation", category: "General" },
      { key: 'node["emergency"="defibrillator"]', value: "Defibrillator (AED)", category: "Safe" },

      
      { key: 'nwr["tourism"="hostel"]', value: "Hostel", category: "Tourism" },
      {
        key: 'nwr["tourism"="camp_site"]',
        value: "Camp Site",
        category: "Tourism",
      },
      { key: 'nwr["tourism"="motel"]', value: "Motel", category: "Tourism" },
      {
        key: 'nwr["tourism"="guest_house"]',
        value: "Guest House",
        category: "Tourism",
      },
      {
        key: 'nwr["tourism"="apartment"]',
        value: "Apartment",
        category: "Tourism",
      },
      {
        key: 'nwr["building"="yes"]',
        value: "Building (general)",
        category: "Buildings",
      },
      {
        key: 'nwr["building"="house"]',
        value: "House",
        category: "Buildings",
      },
      {
        key: 'nwr["building"="apartments"]',
        value: "Apartment Building",
        category: "Buildings",
      },
      {
        key: 'nwr["building"="commercial"]',
        value: "Commercial Building",
        category: "Buildings",
      },
      {
        key: 'nwr["building"="industrial"]',
        value: "Industrial Building",
        category: "Industrial",
      },

      { key: 'nwr["amenity"="bar"]', value: "Bar", category: "Food & Drink" },
      { key: 'nwr["amenity"="cafe"]', value: "Cafe", category: "Food & Drink" },
      { key: 'nwr["amenity"="pub"]', value: "Pub", category: "Food & Drink" },
      {
        key: 'nwr["amenity"="fast_food"]',
        value: "Fast Food",
        category: "Food & Drink",
      },
      {
        key: 'nwr["amenity"="ice_cream"]',
        value: "Ice Cream Shop",
        category: "Food & Drink",
      },
      {
        key: 'nwr["amenity"="food_court"]',
        value: "Food Court",
        category: "Food & Drink",
      },
      {
        key: 'nwr["amenity"="bakery"]',
        value: "Bakery",
        category: "Food & Drink",
      },
      {
        key: 'nwr["amenity"="vineyard"]',
        value: "Vineyard",
        category: "Food & Drink",
      },
      {
        key: 'nwr["amenity"="winery"]',
        value: "Winery",
        category: "Food & Drink",
      },
      {
        key: 'nwr["amenity"="bus_station"]',
        value: "Bus Station",
        category: "Transport",
      },
      {
        key: 'nwr["public_transport"="platform"]',
        value: "Public Transport Platform",
        category: "Transport",
      },
      {
        key: 'nwr["amenity"="ferry_terminal"]',
        value: "Ferry Terminal",
        category: "Transport",
      },
      {
        key: 'nwr["railway"="station"]',
        value: "Train Station",
        category: "Transport",
      },
      {
        key: 'nwr["aeroway"="aerodrome"]',
        value: "Aerodrome",
        category: "Transport",
      },
      {
        key: 'nwr["aeroway"="helipad"]',
        value: "Helipad",
        category: "Transport",
      },
      {
        key: 'nwr["aeroway"="gate"]',
        value: "Airport Gate",
        category: "Transport",
      },
      {
        key: 'nwr["amenity"="car_rental"]',
        value: "Car Rental",
        category: "Transport",
      },
      {
        key: 'nwr["amenity"="car_wash"]',
        value: "Car Wash",
        category: "Transport",
      },
      {
        key: 'nwr["amenity"="taxi"]',
        value: "Taxi Rank",
        category: "Transport",
      },
      {
        key: 'nwr["amenity"="hospital"]',
        value: "Hospital",
        category: "Health",
      },
      { key: 'nwr["amenity"="clinic"]', value: "Clinic", category: "Health" },
      {
        key: 'nwr["amenity"="pharmacy"]',
        value: "Pharmacy",
        category: "Health",
      },
      { key: 'nwr["amenity"="dentist"]', value: "Dentist", category: "Health" },
      {
        key: 'nwr["amenity"="doctors"]',
        value: "Doctor's Office",
        category: "Health",
      },
      {
        key: 'nwr["amenity"="veterinary"]',
        value: "Veterinary",
        category: "Health",
      },
      {
        key: 'nwr["shop"="supermarket"]',
        value: "Supermarket",
        category: "Shopping",
      },
      {
        key: 'nwr["shop"="convenience"]',
        value: "Convenience Store",
        category: "Shopping",
      },
      {
        key: 'nwr["shop"="mall"]',
        value: "Shopping Mall",
        category: "Shopping",
      },
      {
        key: 'nwr["shop"="boutique"]',
        value: "Boutique",
        category: "Shopping",
      },
      {
        key: 'nwr["shop"="outdoor"]',
        value: "Outdoor Shop",
        category: "Shopping",
      },
      {
        key: 'nwr["shop"="sports"]',
        value: "Sports Shop",
        category: "Shopping",
      },
      { key: 'nwr["shop"="gift"]', value: "Gift Shop", category: "Shopping" },
      {
        key: 'nwr["shop"="electronics"]',
        value: "Electronics Store",
        category: "Shopping",
      },
      { key: 'nwr["leisure"="park"]', value: "Park", category: "Leisure" },
      {
        key: 'nwr["leisure"="swimming_pool"]',
        value: "Swimming Pool",
        category: "Leisure",
      },
      {
        key: 'nwr["leisure"="sports_centre"]',
        value: "Sports Centre",
        category: "Leisure",
      },
      { key: 'nwr["leisure"="marina"]', value: "Marina", category: "Leisure" },
      {
        key: 'nwr["leisure"="stadium"]',
        value: "Stadium",
        category: "Leisure",
      },
      {
        key: 'nwr["leisure"="playground"]',
        value: "Playground",
        category: "Leisure",
      },
      { key: 'nwr["tourism"="museum"]', value: "Museum", category: "Tourism" },
      {
        key: 'nwr["tourism"="art_gallery"]',
        value: "Art Gallery",
        category: "Tourism",
      },
      { key: 'nwr["tourism"="zoo"]', value: "Zoo", category: "Tourism" },
      {
        key: 'nwr["tourism"="theme_park"]',
        value: "Theme Park",
        category: "Tourism",
      },
      {
        key: 'nwr["historic"="castle"]',
        value: "Castle",
        category: "Historic",
      },
      {
        key: 'nwr["historic"="monument"]',
        value: "Monument",
        category: "Historic",
      },
      { key: 'nwr["historic"="ruins"]', value: "Ruins", category: "Historic" },
      { key: 'nwr["amenity"="bank"]', value: "Bank", category: "Services" },
      { key: 'nwr["amenity"="atm"]', value: "ATM", category: "Services" },
      {
        key: 'nwr["amenity"="post_office"]',
        value: "Post Office",
        category: "Services",
      },
      {
        key: 'nwr["amenity"="police"]',
        value: "Police Station",
        category: "Services",
      },
      {
        key: 'nwr["amenity"="fire_station"]',
        value: "Fire Station",
        category: "Services",
      },
      {
        key: 'nwr["amenity"="toilets"]',
        value: "Public Toilets",
        category: "Services",
      },
      {
        key: 'nwr["highway"="motorway"]',
        value: "Motorway",
        category: "Roads and Paths",
      },
      {
        key: 'nwr["highway"="trunk"]',
        value: "Trunk Road",
        category: "Roads and Paths",
      },
      {
        key: 'nwr["highway"="primary"]',
        value: "Primary Road",
        category: "Roads and Paths",
      },
      {
        key: 'nwr["highway"="secondary"]',
        value: "Secondary Road",
        category: "Roads and Paths",
      },
      {
        key: 'nwr["highway"="tertiary"]',
        value: "Tertiary Road",
        category: "Roads and Paths",
      },
      {
        key: 'nwr["highway"="residential"]',
        value: "Residential Road",
        category: "Roads and Paths",
      },
      {
        key: 'nwr["highway"="service"]',
        value: "Service Road",
        category: "Roads and Paths",
      },
      {
        key: 'nwr["highway"="track"]',
        value: "Track",
        category: "Roads and Paths",
      },
      {
        key: 'nwr["highway"="path"]',
        value: "Path",
        category: "Roads and Paths",
      },
      {
        key: 'nwr["highway"="cycleway"]',
        value: "Cycleway",
        category: "Roads and Paths",
      },
      {
        key: 'nwr["highway"="footway"]',
        value: "Footway",
        category: "Roads and Paths",
      },
      {
        key: 'nwr["highway"="pedestrian"]',
        value: "Pedestrian Zone",
        category: "Roads and Paths",
      },
      {
        key: 'nwr["highway"="steps"]',
        value: "Steps",
        category: "Roads and Paths",
      },
      {
        key: 'nwr["highway"="bridleway"]',
        value: "Bridleway",
        category: "Roads and Paths",
      },
      {
        key: 'nwr["highway"="unclassified"]',
        value: "Unclassified Road",
        category: "Roads and Paths",
      },
      {
        key: 'nwr["highway"="living_street"]',
        value: "Living Street",
        category: "Roads and Paths",
      },
      {
        key: 'nwr["highway"="motorway_link"]',
        value: "Motorway Link",
        category: "Roads and Paths",
      },
      {
        key: 'nwr["highway"="trunk_link"]',
        value: "Trunk Link",
        category: "Roads and Paths",
      },
      {
        key: 'nwr["highway"="primary_link"]',
        value: "Primary Link",
        category: "Roads and Paths",
      },
      {
        key: 'nwr["highway"="secondary_link"]',
        value: "Secondary Link",
        category: "Roads and Paths",
      },
      {
        key: 'nwr["highway"="tertiary_link"]',
        value: "Tertiary Link",
        category: "Roads and Paths",
      },

      {
        key: 'nwr["waterway"="river"]',
        value: "River",
        category: "Water Features",
      },
      {
        key: 'nwr["waterway"="canal"]',
        value: "Canal",
        category: "Water Features",
      },
      {
        key: 'nwr["waterway"="stream"]',
        value: "Stream",
        category: "Water Features",
      },
      {
        key: 'nwr["waterway"="ditch"]',
        value: "Ditch",
        category: "Water Features",
      },
      {
        key: 'nwr["waterway"="drain"]',
        value: "Drain",
        category: "Water Features",
      },
      {
        key: 'nwr["waterway"="wadi"]',
        value: "Wadi",
        category: "Water Features",
      },
      { key: 'nwr["water"="lake"]', value: "Lake", category: "Water Features" },
      { key: 'nwr["water"="pond"]', value: "Pond", category: "Water Features" },
      {
        key: 'nwr["water"="reservoir"]',
        value: "Reservoir",
        category: "Water Features",
      },
      {
        key: 'nwr["natural"="water"]',
        value: "Water Body",
        category: "Water Features",
      },
      { key: 'nwr["natural"="bay"]', value: "Bay", category: "Water Features" },
      {
        key: 'nwr["natural"="spring"]',
        value: "Spring",
        category: "Water Features",
      },
      {
        key: 'nwr["natural"="hot_spring"]',
        value: "Hot Spring",
        category: "Water Features",
      },
      {
        key: 'nwr["waterway"="dock"]',
        value: "Dock",
        category: "Water Features",
      },
      {
        key: 'nwr["waterway"="boatyard"]',
        value: "Boatyard",
        category: "Water Features",
      },
      {
        key: 'nwr["waterway"="dam"]',
        value: "Dam",
        category: "Water Features",
      },
      {
        key: 'nwr["waterway"="waterfall"]',
        value: "Waterfall",
        category: "Water Features",
      },
      {
        key: 'nwr["waterway"="lock_gate"]',
        value: "Lock Gate",
        category: "Water Features",
      },
      {
        key: 'nwr["waterway"="weir"]',
        value: "Weir",
        category: "Water Features",
      },
      {
        key: 'nwr["landuse"="reservoir"]',
        value: "Reservoir Area",
        category: "Water Features",
      },
      {
        key: 'nwr["landuse"="basin"]',
        value: "Basin",
        category: "Water Features",
      },
    ],
  },

  ADDRESS_POPUPTEMPLATE: {
    title: "Address",
    content: [
      {
        type: "fields",
        fieldInfos: [
          {
            fieldName: "city",
            label: "City",
          },
          {
            fieldName: "code",
            label: "Code",
          },
          {
            fieldName: "street",
            label: "Street",
          },
          {
            fieldName: "number",
            label: "Number",
          },
          {
            fieldName: "teryt",
            label: "TERYT",
          },
          {
            fieldName: "simc",
            label: "SIMC",
          },
          {
            fieldName: "ulic",
            label: "ULIC",
          },

          {
            fieldName: "x",
            label: "X",
          },
          {
            fieldName: "y",
            label: "Y",
          },
        ],
      },
    ],
  },
};
